import styled from 'styled-components'

export const TranscriptionAuthorizerModalContainer = styled.div`
  div p {
    padding-top: 20px;
  }
`

export const ButtonsWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 15px;

  button {
    width: 100%;
    border-radius: 9999px;
  }
`